import __request__ from "routing/request";
export function createFromBuilder(rule) {
  return __request__("POST", "/system/pipelines/rulebuilder", rule, {}, {
    "Accept": ["application/json"]
  });
}
export function actions() {
  return __request__("GET", "/system/pipelines/rulebuilder/actions", null, {}, {
    "Accept": ["application/json"]
  });
}
export function conditions() {
  return __request__("GET", "/system/pipelines/rulebuilder/conditions", null, {}, {
    "Accept": ["application/json"]
  });
}
export function simulate(rule) {
  return __request__("POST", "/system/pipelines/rulebuilder/simulate", rule, {}, {
    "Accept": ["application/json"]
  });
}
export function validate(rule) {
  return __request__("POST", "/system/pipelines/rulebuilder/validate", rule, {}, {
    "Accept": ["application/json"]
  });
}
export function updateFromBuilder(rule, id) {
  return __request__("PUT", `/system/pipelines/rulebuilder/${id}`, rule, {}, {
    "Accept": ["application/json"]
  });
}
